<script lang="ts">
    import type { SvelteComponent } from "svelte";
    export let onClick: (e: MouseEvent) => void;
    export let title: string;
    export let icon: SvelteComponent|any|undefined = undefined;
</script>

<li class="DropdownMenuItem" on:click|stopPropagation={onClick}>
    {#if icon}
        <svelte:component this={icon} width="1rem" height="1rem" color="#333" />
    {/if}
    <span>{title}</span>
</li>

<style type="text/scss">
    .DropdownMenuItem {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        white-space: nowrap;
        width: auto;
        overflow: hidden;
        font-size: 1rem;
        box-sizing: border-box;
        line-height: 1.5;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 6px;
        padding-bottom: 6px;
        white-space: nowrap;
        cursor: pointer;

        :global(svg) {
            margin-right: 5px;
        }
        span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 1rem;
            line-height: 1.5;
        }
        &:hover {
            background: rgb(226, 226, 226);
        }
    }
</style>